(function($) {
    class W4D_Nav {
        constructor() {
            this.initSelectors();
            this.initSlinky();
            this.bindEvents();
            this.setupTransitions();
            this.initSwipeToClose();
            this.checkInitialHover();
        }

        checkInitialHover() {
            requestAnimationFrame(() => {
                $('.nav__links-wrapper > .nav__list > .nav__item').each((index, element) => {
                    const $item = $(element);
                    const isHovered = $item.is(':hover');

                    if (isHovered) {
                        this.logExpandedNavHeight($item);
                    }
                });
            });
        }

        initSelectors() {
            this.$header = $('.w4d-header');
            this.$navToggle = $('.nav__toggle');
            this.$menu = $('[data-slinky-menu]');
            this.$navContainer = $('.nav__container');
            this.$navInner = $('.nav__inner');
            this.$navLinksWrapper = $('.nav__links-wrapper');
        }

        initSlinky() {
            const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

            if (mediaQueryXl.matches) {
                const slinkyOptions = {
                    title: true,
                    speed: 300,
                    resize: true,
                    activeClass: 'active'
                };

                this.slinky = this.$menu.slinky(slinkyOptions);
            }
        }

        setupTransitions() {
            // This prevents unwanted animations on initial load
            setTimeout(() => {
                this.$navContainer.addClass('nav__container--transitions-enabled');
            }, 100);
        }

        reinitSlinkyOnResize() {
            const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

            // Temporarily disable transitions during resize
            this.$navContainer.removeClass('nav__container--transitions-enabled');

            if (mediaQueryXl.matches && !this.slinky) {
                const slinkyOptions = {
                    title: true,
                    speed: 300,
                    resize: true,
                    activeClass: 'active'
                };

                this.slinky = this.$menu.slinky(slinkyOptions);

                // Close navigation when switching to mobile to prevent it from being open
                this.closeNav();
            }

            else if (!mediaQueryXl.matches && this.slinky) {
                if (typeof this.slinky.destroy === 'function') {
                    this.slinky.destroy();
                    this.slinky = null;
                }

                this.closeNav();
            }

            // Re-enable transitions after a short delay
            setTimeout(() => {
                this.$navContainer.addClass('nav__container--transitions-enabled');
            }, 50);
        }

        bindEvents() {
            if (this.$navToggle.length) {
                this.$navToggle.on('click', (e) => {
                    e.preventDefault();
                    this.toggleNav();
                });
            }

            $(window).on('resize', () => {
                this.reinitSlinkyOnResize();
            });

            $('.nav__container').on('click', (e) => {
                if (e.target === e.currentTarget) {
                    this.toggleNav();
                }
            });

            // Close button inside nav
            $('.nav__header .icon-x-rounded').on('click', (e) => {
                e.preventDefault();
                this.toggleNav();
            });

            $('.nav__links-wrapper > .nav__list > .nav__item').on('mouseenter', (e) => {
                this.logExpandedNavHeight($(e.currentTarget));
            });

            $('.nav__links-wrapper > .nav__list').on('mouseleave', (e) => {
                this.clearExpandedNavHeight($(e.currentTarget));
            });

            $(document).on('keyup', (e) => {
                if (e.key === 'Escape' && this.$header.hasClass('w4d-header--open')) {
                    this.toggleNav();
                }
            });

            // Add event listener for nav item clicks to scroll to top
            $(document).on('click', '.nav__item', (e) => {
                const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

                // Only apply on mobile when slinky is active
                if (mediaQueryXl.matches && this.slinky) {
                    this.scrollNavToTop();
                }
            });
        }

        scrollNavToTop() {
            if (this.$navLinksWrapper.length) {
                this.$navLinksWrapper.animate({
                    scrollTop: 0
                }, 300); // 300ms animation duration
            }
        }


        toggleNav() {
            this.$header.toggleClass('w4d-header--open');
            this.$navToggle.toggleClass('nav__toggle--open');
        }

        closeNav() {
            this.$header.removeClass('w4d-header--open');
            this.$navToggle.removeClass('nav__toggle--open');

            // Reset nav position
            this.$navInner[0].style.transform = '';
            this.$navInner[0].style.transition = '';
        }

        logExpandedNavHeight($hoveredItem) {
            const $expandedNav = $hoveredItem.find('.nav__list[data-level="2"]:visible');

            if ($expandedNav.length) {
                // Clean up siblings first
                $hoveredItem.siblings('.nav__item--submenu-open')
                    .removeClass('nav__item--submenu-open')
                    .find('.nav__link--animate-in')
                    .removeClass('nav__link--animate-in');

                const height = $expandedNav.outerHeight();
                $hoveredItem.parent().css('--submenu-height', `${height}px`);

                // Add animation class when submenu opens
                $hoveredItem.addClass('nav__item--submenu-open');

                // Trigger animations for individual links
                this.animateSubmenuLinks($expandedNav);
            }
        }

        clearExpandedNavHeight($navContainer) {
            $navContainer.css('--submenu-height', '');

            // Remove animation classes when submenu closes
            $navContainer.find('.nav__item').removeClass('nav__item--submenu-open');
            $navContainer.find('.nav__link').removeClass('nav__link--animate-in');
        }

        animateSubmenuLinks($submenu) {
            const $links = $submenu.find('> .nav__item .nav__link');
            const $linksLevel3 = $submenu.find('.nav__list[data-level="3"] .nav__link');

            // Reset any existing animations
            $links.removeClass('nav__link--animate-in');
            $linksLevel3.removeClass('nav__link--animate-in');

            // Add animation class with staggered delay
            $links.each((index, link) => {
                setTimeout(() => {
                    $(link).addClass('nav__link--animate-in');
                }, index * 5);
            });
        }

        initSwipeToClose() {
            this.swipe = {
                startX: 0,
                startY: 0,
                currentX: 0,
                startTime: 0,
                isActive: false,
                isHorizontalSwipe: false,
                threshold: 50,
                closeThreshold: 0.4,
                durationThreshold: 1000
            };

            if ('ontouchstart' in window) {
                const navInnerElement = this.$navInner[0];

                navInnerElement.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
                navInnerElement.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
                navInnerElement.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
                navInnerElement.addEventListener('touchcancel', this.handleTouchEnd.bind(this), { passive: true });
            }
        }

        handleTouchStart(e) {
            if (!this.$header.hasClass('w4d-header--open')) return;
            if (this.$header.find('.dropdown.dropdown--open').length > 0) return;

            const touch = e.touches[0];
            this.swipe = {
                ...this.swipe,
                startX: touch.clientX,
                startY: touch.clientY,
                currentX: touch.clientX,
                startTime: Date.now(),
                isActive: true,
                isHorizontalSwipe: false
            };

            // Clear any existing transforms and transitions
            this.$navInner[0].style.transition = '';
            this.$navInner.addClass('nav__inner--swiping');
        }

        handleTouchMove(e) {
            if (!this.swipe.isActive || !this.$header.hasClass('w4d-header--open')) return;

            const touch = e.touches[0];
            const deltaX = touch.clientX - this.swipe.startX;
            const deltaY = touch.clientY - this.swipe.startY;
            const currentTime = Date.now();
            const duration = currentTime - this.swipe.startTime;

            // Check duration threshold
            if (duration > this.swipe.durationThreshold) {
                this.endSwipe(true); // Force bounce back
                return;
            }

            // Determine swipe direction
            if (!this.swipe.isHorizontalSwipe && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
                this.swipe.isHorizontalSwipe = true;
            }

            // Only handle rightward horizontal swipes
            if (this.swipe.isHorizontalSwipe && deltaX > 0) {
                e.preventDefault();
                this.swipe.currentX = touch.clientX;

                const navWidth = this.$navInner.outerWidth();
                const swipePercentage = deltaX / navWidth;

                // Immediate close when threshold is reached
                if (swipePercentage >= this.swipe.closeThreshold) {
                    this.endSwipe(false); // Trigger close
                    return;
                }

                // Update position smoothly
                const swipeDistance = Math.max(0, deltaX);
                this.$navInner[0].style.transform = `translateX(${swipeDistance}px)`;
            }
        }

        handleTouchEnd(e) {
            if (!this.swipe.isActive) return;

            const deltaX = this.swipe.currentX - this.swipe.startX;
            const duration = Date.now() - this.swipe.startTime;
            const navWidth = this.$navInner.outerWidth();
            const swipePercentage = deltaX / navWidth;
            const velocity = this.calculateVelocity(deltaX, duration);

            // Determine action based on swipe
            const shouldClose = this.swipe.isHorizontalSwipe &&
                deltaX > this.swipe.threshold &&
                duration <= this.swipe.durationThreshold &&
                (swipePercentage >= this.swipe.closeThreshold || velocity > 0.8);

            this.endSwipe(!shouldClose);
        }

        endSwipe(shouldBounceBack) {
            if (!this.swipe.isActive) return;

            this.swipe.isActive = false;
            this.$navInner.removeClass('nav__inner--swiping');

            if (shouldBounceBack) {
                this.animateNavBounceBack();
            } else {
                this.animateNavClose();
            }

            this.resetSwipeData();
        }

        calculateVelocity(distance, duration) {
            if (duration <= 0) return 0;
            const navWidth = this.$navInner.outerWidth();
            const normalizedDistance = Math.abs(distance / navWidth);
            return normalizedDistance / (duration / 1000);
        }

        animateNavClose() {
            const navWidth = this.$navInner.outerWidth();
            this.$navInner[0].style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            this.$navInner[0].style.transform = `translateX(${navWidth}px)`;

            setTimeout(() => {
                this.closeNav();
            }, 300);
        }

        animateNavBounceBack() {
            this.$navInner[0].style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
            this.$navInner[0].style.transform = 'translateX(0)';

            setTimeout(() => {
                this.$navInner[0].style.transition = '';
            }, 400);
        }

        resetSwipeData() {
            this.swipe.isActive = false;
            this.swipe.isHorizontalSwipe = false;
            this.swipe.startX = 0;
            this.swipe.currentX = 0;
            this.swipe.startTime = 0;
        }

    }

    $(document).ready(() => new W4D_Nav());
})(jQuery);